<div class="dashboard">
  <lib-dashboard [refreshIntervalInSeconds]="30"  [userPreferences]="userPreferences" (uiEvents)="uiEventHandler($event)" (dashboardReady)="setDashboardReadyState()"></lib-dashboard>
</div>
<gpp-ui-loading-indicator [showSpinner]="dashboardReadyIndicator"></gpp-ui-loading-indicator>
